import { Component, Prop, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import { BFormGroup } from "@/lib/typed-bootstrap";
import { upperCaseFirstLetter } from "@/utils";

@Component
export default class FormReadonly extends Vue {
  _tsx!: tsx.DeclareProps<{
    id?: FormReadonly["id"];
    value?: FormReadonly["value"];
    label: FormReadonly["label"];
    labelAmendment: FormReadonly["labelAmendment"];
    upperCaseLabel?: FormReadonly["upperCaseLabel"];
  }>;

  @Prop() id?: string;
  @Prop() value!: any;
  @Prop({ required: true }) readonly label!: string;
  @Prop({ required: true }) readonly labelAmendment!: string;
  @Prop({ default: true }) readonly upperCaseLabel!: boolean;

  get fieldName(): string {
    return `formReadonlyInput${upperCaseFirstLetter(this.id ?? "unknown")}`;
  }

  get readonlyValue(): string {
    return this.value ?? this.$t("form_placeholder_auto_generated");
  }

  render() {
    return (
      <BFormGroup
        class={["default__form-group", { uppercase: this.upperCaseLabel }]}
      >
        <label>
          {this.labelAmendment && (
            <span class="form-group__label-amendment">
              {this.labelAmendment}
            </span>
          )}
          {this.label}
        </label>

        <div data-testid={this.fieldName} class="form-group__readonly-value">
          {this.readonlyValue}
        </div>
      </BFormGroup>
    );
  }
}
